import React, { useEffect, useState } from "react";
import './../Stripe.css';
import {
  PaymentElement,
  usePaymentClient,
  usePaymentElements
} from "../payments";

export default function AddNewPayment(props) {
  const stripe = usePaymentClient();
  const elements = usePaymentElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [return_url, setReturnUrl] = useState(`${window.location.origin}/statement-summary`);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = props.clientSecret;

    if (!clientSecret) {
      return;
    }

    if (props.manageAccount) {
      setReturnUrl(`${window.location.origin}/account`);
    }

    stripe.retrieveSetupIntent(clientSecret);
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    let { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: return_url
      }
    })

    if (error && (error.type === "card_error" || error.type === "validation_error")) {
      setMessage(error.message);
    } else if (error) {
      setMessage("An unexpected error occured.");
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Add Payment Method"}
        </span>
      </button>
      {message && <div className='errors-stripe' id="payment-message">{message}</div>}
    </form>
  );
}
